function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_253_9446)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.92871 16.0001L14.3406 1.20898L10.2991 2.18084L7.92871 16.0001Z",
  fill: "#99D6EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.98942 3.47269L6.61312 2.47713L1.54053 1.20898L7.92868 16.0001L4.98942 3.47269Z",
  fill: "#FDB71A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.74365 3.04593L10.2992 2.18074L10.7022 0L6.61328 2.47704L6.74365 3.04593Z",
  fill: "#99D6EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.92884 16.0009L10.2992 2.18164L6.74365 3.04683L7.92884 16.0009Z",
  fill: "#00A9E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.61296 2.47656L4.98926 3.47212L6.74333 3.04545L6.61296 2.47656Z",
  fill: "#AFA96E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.98926 3.47354L7.92852 16.0009L6.74333 3.04688L4.98926 3.47354Z",
  fill: "#A09958"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_253_9446"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgFavLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavLogoIcon);
export default __webpack_public_path__ + "static/media/fav-logo-icon.c47e9d87.svg";
export { ForwardRef as ReactComponent };